import { graphql } from '@/generated/gql';

export const THREAD_LIST_BY_CATEGORIES_QUERY = graphql(/* GraphQL */ `
  query ThreadListByCategories(
    $offset: Int
    $limit: Int
    $filter: SvbrgQueryBuilderQuery
    $order: [SvbrgThreadOrder!]
    $categories: [SvbrgCategoryType!]
  ) {
    sevenbridges {
      threadList(offset: $offset, limit: $limit, filter: $filter, order: $order, categories: $categories) {
        nodes {
          id
          sequenceNumber
          createdAt
          createdBy
          status
          demandId
          demandSequenceNumber
          demandResponsibleUsers
          summary
          variant
          conversationSettingsEntityId
          conversationSettingsEntityVariant
        }
        totalCount
      }
    }
  }
`);
